import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function BasketIcon(props: SvgIconProps) {
	return (
		<SvgIcon
			{...props}
			width="21"
			height="19"
			viewBox="0 0 21 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_6128_300)">
				<path
					d="M12.4808 12.2514L16.8429 15.3975L16.2794 16.2019L11.1814 12.5253C10.5086 12.0392 9.60512 12.0392 8.93235 12.5253L3.83432 16.2019L3.27084 15.3975L7.63295 12.2514L-0.000732422 7.16089V18.5387C-0.000732422 18.7953 0.203286 19.0026 0.45588 19.0026H19.6603C19.9129 19.0026 20.1169 18.7953 20.1169 18.5387V7.16089L12.4808 12.2514Z"
					fill="#7F7F87"
				/>
				<path
					d="M2.32837 0.017334V1.00435C3.86336 1.00435 5.29635 1.46578 6.49617 2.25785L7.3681 1.66811C5.94969 0.629282 4.20825 0.017334 2.32837 0.017334Z"
					fill="#7F7F87"
				/>
				<path
					d="M10.4531 0.120922C10.2127 -0.041935 9.90423 -0.041935 9.66378 0.120922L7.36857 1.66807C9.26789 3.05729 10.594 5.20897 10.9073 7.67897L12.8722 5.64819L13.5644 6.3391L10.5479 9.45807L10.2078 9.20391C9.68564 8.81404 7.73775 7.88378 7.03097 7.56053L7.43172 6.66235C7.63088 6.75365 8.98372 7.3804 9.95766 7.91092C9.6905 5.54209 8.37409 3.49651 6.49421 2.25781L0.492676 6.30949L8.49067 11.6418C9.44519 11.0225 10.6717 11.0225 11.6262 11.6418L19.6242 6.30949L10.4531 0.120922Z"
					fill="#7F7F87"
				/>
			</g>
			<defs>
				<clipPath id="clip0_6128_300">
					<rect width="20.1176" height="19" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
}
